import { Box, Typography, Button } from "@mui/material";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import axiosInstance from "../../api/axiosInstance";
import { ENV } from "../../config/env"

const DocumentDetail = () => {
  const { docSlug } = useParams();
  const [doc, setDoc] = useState(null);

  useEffect(() => {
    axiosInstance
      .get(`/api/cdmp-documents?filters[slug][$eq]=${docSlug}&populate=*`)
      .then((res) => {
        setDoc(res.data.data[0]);
      });
  }, [docSlug]);

  if (!doc) return <Typography>Loading...</Typography>;

  return (
    <Box sx={{ px: 4, py: 4 }}>
      <Typography variant="h4" mb={2}>
        {doc.title}
      </Typography>

      <Typography mb={3}>
        {doc.description}
      </Typography>

      <Button
        variant="contained"
        onClick={() =>
          window.open(
            ENV.API_BASE_URL + doc.pdfFile[0].url,
            "_blank"
          )
        }
      >
        Download PDF
      </Button>
    </Box>
  );
};

export default DocumentDetail;
